import Vue from 'vue';
import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);

let vm = new Vue();

// el弹窗
export const successAlert = (msg) => {
    vm.$message({
        message: msg,
        type: 'success'
    });
}
export const messageAlert = (msg) => {
    vm.$message(msg);
}